const stringsIT = {
  'general.loggingIn': 'Accesso in corso...',
  'general.invalidPassword': 'Password non valida, riprova',
  'general.goToLogin': "Vai all'accesso",
  'general.loggedOutText': 'Sei stato scollegato',
  'general.changePassword': 'Modifica password',
  'general.modified': 'Modificato',
  'general.mobile': 'Mobile',
  'general.desktop': 'Desktop',
  'general.backTo': 'Torna a',
  'general.synced': 'Sincronizzato',
  'general.assigned': 'assegnato',
  'general.notAssigned': 'non assegnato',
  'menuLabel.notesAndDocuments': 'Note e documenti',
  'plants.filterByTag': 'Filtra per tag',
  'plants.recentlyModified': 'ordina per modifica recente',
  'plants.plantName': 'ordina per nome impianto',
  'newPlantDialog.insertGroup': '+ aggiungi un nuovo gruppo e premi Invio',
  'plantDetail.addDevice': 'Aggiungi dispositivo',
  'plantDetail.addObjects': 'Aggiungi oggetti',
  'plants.noPlantsHint':
    'Clicca sul pulsante "Nuovo impianto" per creare un nuovo impianto',
  'plantDetail.newUpdates': 'Nuovi aggiornamenti',
  'plantDetail.willRefreshToReflectChanges':
    'Questo elemento è stato aggiornato. La pagina sarà ricaricata per mostrare i cambiamenti.',
  'plantDetail.addGroup': 'Aggiungi gruppo',
  'plantDetail.addScene': 'Aggiungi scenario',
  'plantC300EOSSettings.GeneralSettings': 'Impostazioni generali',
  'plantC300EOSSettings.DoorEntryParametrs': 'PARAMETRI VIDEOCITOFONIA',
  'plantC300EOSSettings.descPage':
    "Non tutti i parametri sono modificabili da questa sezione: dovrai farlo sull'impianto con l'app connessa",
  'general.favourites': 'Favoriti',
  'general.select': 'Seleziona',
  'general.operationError': "Errore nell'operazione",
  'plantDetail.lastScan': 'Ultima scansione: {date} alle {time}',
  'general.assignIcon': "Assegna l'icona",
  'general.assignedIcon': 'Icona assegnata',
  'newPlantDialog.modified': 'Impianto modificato',
  'plantDetail.deletePlantConfirm':
    'Sei sicuro di volr cancellare {plantName}? Tutti i dati saranno persi. Per cancellare inserisci il codice {code} e conferma',
  'plantDetail.objectsCreated': 'Oggetti creati con successo',
  'plantDetail.selectDevice':
    'Seleziona un dispositivo per vedere i suoi moduli',
  'plantDetail.typeNameGroup': 'Tipo e nome del gruppo',
  'plantDetail.disableScene': 'Disabilita scenario',
  'plantDetail.disableSceneConfirm':
    'Sei sicuro di voler disabilitare lo scenario "{sceneName}"?',
  'plantC300EOSSettings.SetAsPrimaryEntryUnitDESC':
    "Il posto esterno primario è l'unico che trasferisce la chiamata dall'app e gestisce la segreteria",
  'plantC300EOSSettings.ProfessionalStudioDESC':
    "Quando abilitato dall'utente, studio prefessionale apre automaticamente la serratura ogni volta che qualcuno suona",
  'scenes.trigger': 'condizione di avvio',
  'uniqueNaming.validationError': 'Il nome non è valido',
  'uniqueNaming.unavailableName': 'Nome non disponibile',
  'uniqueNaming.roomInlineNamingError': 'Non è possibile aggiornare il nome',
  'uniqueNaming.roomInlineNamingSuccess': 'Nome della stanza aggiornato',
  'uniqueNaming.nameResetDisclaimer':
    'Il nome sarà riportato a quello iniziale',
  'uniqueNaming.validationErrorWithSuggestion':
    'Il nome non è valido, puoi provare con: "{suggestedName}"',
  'plantsList.duplicateDialog.inputLabel':
    'Puoi correggere i nomi degli impianti qui',
  'plantDialogDuplicate.howManyCopies': 'Quante copie',
  'plantDialogDuplicate.success': 'Impianto duplicato',
  'general.actuatorAdded': 'Attuatore aggiunto',
  'general.commandAdded': 'Comando aggiunto',
  isEditingPlant: 'sta modificando la configurazione',
  eliotParseException:
    "Problema nella lettura della configurazione d'impianto dal cloud.", // assignObject: {
  //   selectFromLastScan: 'Select from last scan',
  //   selectFromCatalogue: 'Select from catalogue',
  // },
  // assignThermo: {
  //   selectOnlyOneDescription:
  //     'TEMP STRING You should select one and only one device.',
  //   thermostatAdded: 'Thermostat added',
  //   heatingActuatorAdded: 'Heating actuator added',
  //   coolingActuatorAdded: 'Cooling actuator added',
  //   sharedActuatorAdded: 'Shared actuator added',
  //   heatingPumpAdded: 'Heating pump added',
  //   coolingPumpAdded: 'Cooling pump added',
  //   sharedPumpAdded: 'Shared pump added',
  //   probeAdded: 'Probe added',
  // },
  'saveAndContinue': 'Salva e continua'
};
export default stringsIT;
